module.exports = __webpack_public_path__ + "img/stop-e.2c9deb2e.png";